// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

.sesb-page {
  padding: 32px 48px 48px;
  max-width: 1400px;
  margin: 0 auto;
}
@media (max-width: 991px) {
  .sesb-page {
    padding: 24px 28px 36px;
  }
}
@media (max-width: 640px) {
  .sesb-page {
    padding: 16px 16px 28px;
  }
}

.sesb-card {
  background: #fff;
  border: 1px solid #e7eaec;
  border-radius: 8px;
  padding: 20px 22px;
}

.sesb-header {
  margin-bottom: 22px;
}
@media (max-width: 640px) {
  .sesb-header {
    margin-bottom: 16px;
  }
}
.sesb-header__title-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.sesb-header__title {
  font-size: 28px;
  font-weight: 700;
  color: #6d6e71;
  margin: 0;
  letter-spacing: -0.02em;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  line-height: 1.2;
}
@media (max-width: 640px) {
  .sesb-header__title {
    font-size: 22px;
  }
}
.sesb-header__meta {
  margin-top: 8px;
  font-size: 13px;
  color: #ccc;
}
.sesb-header__dot {
  margin: 0 6px;
}

.sesb-breadcrumb {
  display: flex;
  align-items: center;
  list-style: none;
  padding: 0;
  margin: 0 0 8px;
  font-size: 12px;
  color: #ccc;
}
.sesb-breadcrumb li {
  display: flex;
  align-items: center;
}
.sesb-breadcrumb li:not(:last-child)::after {
  content: "/";
  margin: 0 8px;
  color: #ccc;
  font-size: 11px;
}
.sesb-breadcrumb li a {
  color: #676a6c;
  text-decoration: none;
  transition: color 0.15s ease;
}
.sesb-breadcrumb li a:hover {
  color: rgb(0, 173, 208);
}
.sesb-breadcrumb__current {
  color: #6d6e71;
  font-weight: 600;
}

.sesb-badge {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  padding: 3px 9px;
  border-radius: 20px;
}
.sesb-badge--split {
  background: rgba(0, 173, 208, 0.12);
  color: #006174;
}
.sesb-badge--active {
  background: rgba(105, 190, 40, 0.12);
  color: #3f7218;
}
.sesb-badge--expired {
  background: rgba(245, 67, 89, 0.12);
  color: #ee0d29;
}

.sesb-toolbar, .sesb-selbar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 14px;
}
.sesb-toolbar__gap, .sesb-selbar__gap {
  flex: 1;
}

.sesb-selbar {
  background: rgba(0, 173, 208, 0.06);
  border: 1px solid rgba(0, 173, 208, 0.28);
  border-radius: 8px;
  padding: 8px 12px;
}
.sesb-selbar__n {
  font-size: 13px;
  font-weight: 600;
  color: #006174;
  margin-right: 4px;
}

.sesb-selbar--groups {
  border-left-width: 3px;
}

.sesb-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 34px;
  padding: 0 14px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  background: #fff;
  color: #6d6e71;
  font-size: 13px;
  font-weight: 600;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  line-height: 1;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.15s ease;
}
.sesb-btn i {
  font-size: 12px;
}
.sesb-btn:hover {
  background: #f1f1f2;
  border-color: #d6dbde;
}
.sesb-btn--primary {
  background: rgb(105, 190, 40);
  color: #fff;
  border-color: rgb(105, 190, 40);
}
.sesb-btn--primary:hover {
  background: #4cae4c;
  border-color: #4cae4c;
}
.sesb-btn--danger {
  color: rgb(245, 67, 89);
  border-color: rgba(245, 67, 89, 0.4);
}
.sesb-btn--danger:hover {
  background: rgba(245, 67, 89, 0.08);
  border-color: rgb(245, 67, 89);
}
.sesb-btn--ghost {
  border-color: transparent;
  background: transparent;
  color: #ccc;
}
.sesb-btn--ghost:hover {
  background: #f1f1f2;
  color: #6d6e71;
}
.sesb-btn:focus-visible {
  outline: 2px solid rgb(105, 190, 40);
  outline-offset: 1px;
}

.sesb-dl {
  position: relative;
}
.sesb-dl__caret {
  margin-left: 2px;
  font-size: 11px;
}
.sesb-dl__backdrop {
  position: fixed;
  inset: 0;
  z-index: 10;
}
.sesb-dl__menu {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  z-index: 11;
  min-width: 200px;
  padding: 6px;
  background: #fff;
  border: 1px solid #e7eaec;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}
.sesb-dl__item {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 10px;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #6d6e71;
  font-size: 13px;
  font-weight: 500;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  text-align: left;
  cursor: pointer;
}
.sesb-dl__item i {
  font-size: 12px;
  color: #ccc;
}
.sesb-dl__item:hover {
  background: #f1f1f2;
}

.sesb-movebox {
  width: 200px;
}
.sesb-movebox .fsc__control {
  height: 34px;
  padding-top: 0;
  padding-bottom: 0;
}

.invkm {
  position: fixed;
  inset: 0;
  z-index: 100000;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 50px 20px;
}
@media only screen and (min-width: 768px) {
  .invkm {
    padding-left: 240px;
  }
}
.invkm__overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 0;
}
.invkm__card {
  position: relative;
  z-index: 1;
  width: min(500px, 100%);
  max-height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.18), 0 0 0 1px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}
.invkm__header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  background: linear-gradient(135deg, #f1f1f2, #ececed);
  border-bottom: 1px solid #e7eaec;
}
.invkm__header-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: rgb(105, 190, 40);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
}
.invkm__title {
  font-size: 15px;
  font-weight: 700;
  color: #6d6e71;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  margin: 0;
  line-height: 1.3;
}
.invkm__subtitle {
  font-size: 12px;
  color: #676a6c;
  margin: 2px 0 0;
  line-height: 1.3;
  opacity: 0.7;
}
.invkm__close {
  margin-left: auto;
  width: 30px;
  height: 30px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  color: #ccc;
  transition: all 0.15s ease;
  flex-shrink: 0;
}
.invkm__close:hover {
  background: rgba(245, 67, 89, 0.06);
  color: rgb(245, 67, 89);
  border-color: rgba(245, 67, 89, 0.2);
}
.invkm__body {
  padding: 20px;
  overflow-y: auto;
}
.invkm__section {
  font-size: 13px;
  font-weight: 700;
  color: #6d6e71;
  margin: 0 0 14px;
}
.invkm__footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 12px 20px;
  border-top: 1px solid #e7eaec;
}

.invkm-field {
  margin-bottom: 16px;
}
.invkm-field label {
  display: block;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6d6e71;
  margin-bottom: 6px;
}
.invkm-field .form-control {
  width: 100%;
  padding: 9px 12px;
  font-size: 13px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  color: #676a6c;
  background: #fff;
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.invkm-field .form-control:focus {
  border-color: rgb(0, 173, 208);
  box-shadow: 0 0 0 3px rgba(0, 173, 208, 0.1);
}

.invkm-req {
  color: rgb(245, 67, 89);
}

.invkm-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 9px 18px;
  font-size: 13px;
  font-weight: 600;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  border: 1px solid transparent;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s ease;
}
.invkm-btn--primary {
  background: rgb(105, 190, 40);
  color: #fff;
}
.invkm-btn--primary:hover {
  background: #569c21;
}
.invkm-btn--primary[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
}
.invkm-btn--purchase {
  background: rgb(0, 173, 208);
  color: #fff;
  margin-top: 14px;
  width: 100%;
}
.invkm-btn--purchase:hover {
  background: #008ba7;
}
.invkm-btn--ghost {
  background: none;
  color: #ccc;
  border-color: transparent;
}
.invkm-btn--ghost:hover {
  color: #676a6c;
}

.invkm .invkm__card--combo {
  overflow: visible;
  max-height: none;
}
.invkm .invkm__card--combo .invkm__header {
  border-radius: 12px 12px 0 0;
}
.invkm .invkm__card--combo .invkm__footer {
  border-radius: 0 0 12px 12px;
}

.invkm .invkm__body--combo {
  overflow: visible;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/sessions/board/session-board-page.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AA7YA;EACE,uBAAA;EACA,iBAAA;EACA,cAAA;AAgZF;AA9YE;EALF;IAK8B,uBAAA;EAkZ5B;AACF;AAlZE;EANF;IAM8B,uBAAA;EAsZ5B;AACF;;AApZA;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;AAuZF;;AAnZA;EACE,mBAAA;AAsZF;AApZE;EAHF;IAG8B,mBAAA;EAwZ5B;AACF;AAvZE;EAAe,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,eAAA;AA6ZhE;AA3ZE;EACE,eAAA;EACA,gBAAA;EACA,cDYiB;ECXjB,SAAA;EACA,uBAAA;EACA,wED/BS;ECgCT,gBAAA;AA6ZJ;AA3ZI;EATF;IAS8B,eAAA;EA+Z9B;AACF;AA7ZE;EAAU,eAAA;EAAiB,eAAA;EAAiB,WDK1B;AC6ZpB;AAjaE;EAAS,aAAA;AAoaX;;AAjaA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,eAAA;EACA,WDNkB;AC0apB;AAlaE;EACE,aAAA;EACA,mBAAA;AAoaJ;AAlaI;EAA4B,YAAA;EAAc,aAAA;EAAe,WDZzC;ECYoE,eAAA;AAwaxF;AAtaI;EACE,cDtBe;ECuBf,qBAAA;EACA,4BAAA;AAwaN;AAvaM;EAAU,uBDvCA;ACidhB;AAtaE;EAAa,cDxBM;ECwBsB,gBAAA;AA0a3C;;AAvaA;EACE,eAAA;EAAiB,gBAAA;EAAkB,yBAAA;EAA2B,qBAAA;EAC9D,gBAAA;EAAkB,mBAAA;AA8apB;AA5aE;EAAW,mCAAA;EAAwC,cAAA;AAgbrD;AA/aE;EAAY,oCAAA;EAAwC,cAAA;AAmbtD;AAlbE;EAAa,mCAAA;EAA0C,cAAA;AAsbzD;;AAnbA;EACE,aAAA;EAAe,mBAAA;EAAqB,QAAA;EAAU,eAAA;EAAiB,mBAAA;AA0bjE;AAzbE;EAAS,OAAA;AA4bX;;AA1bA;EACE,mCAAA;EAAwC,yCAAA;EACxC,kBAAA;EAAoB,iBAAA;AA+btB;AA9bE;EAAO,eAAA;EAAiB,gBAAA;EAAkB,cAAA;EAAoC,iBAAA;AAochF;;AA/bA;EAAuB,sBAAA;AAmcvB;;AA/bA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cD7DmB;EC8DnB,eAAA;EACA,gBAAA;EACA,wEDxGW;ECyGX,cAAA;EACA,eAAA;EACA,mBAAA;EACA,0BAAA;AAkcF;AAhcE;EAAI,eAAA;AAmcN;AAlcE;EAAU,mBDpEU;ECoEwB,qBAAA;AAsc9C;AApcE;EACE,6BD3FY;EC2FgB,WAAA;EAAa,+BD3F7B;ACmiBhB;AAvcI;EAAU,mBDtEK;ECsE0B,qBDtE1B;ACihBnB;AAxcE;EACE,uBD/Fc;EC+FW,oCAAA;AA2c7B;AA1cI;EAAU,mCAAA;EAA0C,8BDhGtC;AC8iBlB;AA3cE;EACE,yBAAA;EAA2B,uBAAA;EAAyB,WDlFpC;ACiiBpB;AA9cI;EAAU,mBDlFQ;ECkF0B,cDrF3B;ACuiBrB;AA/cE;EAAkB,oCAAA;EAAmC,mBAAA;AAmdvD;;AA/cA;EACE,kBAAA;AAkdF;AAhdE;EAAW,gBAAA;EAAkB,eAAA;AAod/B;AAndE;EAAc,eAAA;EAAiB,QAAA;EAAU,WAAA;AAwd3C;AAvdE;EACE,kBAAA;EAAoB,qBAAA;EAAuB,OAAA;EAAS,WAAA;EACpD,gBAAA;EAAkB,YAAA;EAClB,gBAAA;EAAkB,yBAAA;EAAiC,kBAAA;EACnD,0CAAA;AA+dJ;AA7dE;EACE,aAAA;EAAe,mBAAA;EAAqB,QAAA;EAAU,WAAA;EAC9C,iBAAA;EAAmB,YAAA;EAAc,kBAAA;EAAoB,uBAAA;EACrD,cD1GiB;EC0GW,eAAA;EAAiB,gBAAA;EAAkB,wEDlJtD;ECmJT,gBAAA;EAAkB,eAAA;AAyetB;AAxeI;EAAI,eAAA;EAAiB,WD1GL;ACslBpB;AA3eI;EAAU,mBD1GQ;ACwlBtB;;AAveA;EACE,YAAA;AA0eF;AAzeE;EAAgB,YAAA;EAAc,cAAA;EAAgB,iBAAA;AA8ehD;;AAneA;EACE,eAAA;EACA,QAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,kBAAA;AAseF;AApeE;EATF;IASyB,mBAAA;EAwevB;AACF;AAveE;EAAa,eAAA;EAAiB,QAAA;EAAU,+BAAA;EAAiC,UAAA;AA6e3E;AA5eE;EACE,kBAAA;EACA,UAAA;EACA,uBAAA;EACA,+BAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,0EAAA;EACA,gBAAA;AA8eJ;AA5eE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,qDAAA;EACA,gCAAA;AA8eJ;AA5eE;EAAiB,WAAA;EAAa,YAAA;EAAc,kBAAA;EAAoB,6BDlLlD;ECkL8E,WAAA;EAAa,aAAA;EAAe,mBAAA;EAAqB,uBAAA;EAAyB,eAAA;EAAiB,cAAA;AAwfzL;AAvfE;EAAW,eAAA;EAAiB,gBAAA;EAAkB,cDlK3B;ECkKuD,wED1M/D;EC0MyF,SAAA;EAAW,gBAAA;AA+fjH;AA9fE;EAAc,eAAA;EAAiB,cDxKZ;ECwKwC,eAAA;EAAiB,gBAAA;EAAkB,YAAA;AAqgBhG;AApgBE;EACE,iBAAA;EAAmB,WAAA;EAAa,YAAA;EAAc,yBAAA;EAAiC,kBAAA;EAAoB,gBAAA;EACnG,eAAA;EAAiB,aAAA;EAAe,mBAAA;EAAqB,uBAAA;EAAyB,eAAA;EAAiB,WDpK/E;ECqKhB,0BAAA;EAA4B,cAAA;AAihBhC;AAhhBI;EAAU,mCAAA;EAA0C,uBDxLtC;ECwL+D,oCAAA;AAqhBjF;AAnhBE;EAAU,aAAA;EAAe,gBAAA;AAuhB3B;AAthBE;EAAa,eAAA;EAAiB,gBAAA;EAAkB,cD3K7B;EC2KyD,gBAAA;AA4hB9E;AA3hBE;EAAY,aAAA;EAAe,yBAAA;EAA2B,SAAA;EAAW,kBAAA;EAAoB,6BAAA;AAkiBvF;;AA9hBA;EACE,mBAAA;AAiiBF;AAhiBE;EAAQ,cAAA;EAAgB,eAAA;EAAiB,gBAAA;EAAkB,yBAAA;EAA2B,sBAAA;EAAwB,cDlL3F;ECkLuH,kBAAA;AAyiB5I;AAxiBE;EACE,WAAA;EAAa,iBAAA;EAAmB,eAAA;EAAiB,yBAAA;EAAiC,kBAAA;EAClF,cD1LiB;EC0LW,gBAAA;EAAkB,aAAA;EAAe,wDAAA;AAijBjE;AAhjBI;EAAU,8BDzME;ECyM4B,4CAAA;AAojB5C;;AAjjBA;EAAa,uBDzMK;AC8vBlB;;AAnjBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,wED3OW;EC4OX,6BAAA;EACA,kBAAA;EACA,eAAA;EACA,0BAAA;AAsjBF;AApjBE;EAAa,6BD1NC;EC0N2B,WAAA;AAwjB3C;AAxjBwD;EAAU,mBAAA;AA2jBlE;AA3jB4G;EAAc,YAAA;EAAc,mBAAA;AA+jBxI;AA9jBE;EAAc,4BD7NA;EC6N4B,WAAA;EAAa,gBAAA;EAAkB,WAAA;AAokB3E;AApkBwF;EAAU,mBAAA;AAukBlG;AAtkBE;EAAW,gBAAA;EAAkB,WDzMX;ECyMsC,yBAAA;AA2kB1D;AA3kBqF;EAAU,cDhN1E;AC8xBrB;;AAtkBA;EACE,iBAAA;EACA,gBAAA;AAykBF;AAxkBE;EAAiB,4BAAA;AA2kBnB;AA1kBE;EAAiB,4BAAA;AA6kBnB;;AA3kBA;EAA6B,iBAAA;AA+kB7B","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import \"../../../../assets/styles/variables\";\n\n.sesb-page {\n  padding: 32px 48px 48px;\n  max-width: 1400px;\n  margin: 0 auto;\n\n  @media (max-width: 991px) { padding: 24px 28px 36px; }\n  @media (max-width: 640px) { padding: 16px 16px 28px; }\n}\n\n.sesb-card {\n  background: #fff;\n  border: 1px solid $color-grey-1;\n  border-radius: 8px;\n  padding: 20px 22px;\n}\n\n// ── Page header (breadcrumb + title), matching the listing/wizard chrome ──\n.sesb-header {\n  margin-bottom: 22px;\n\n  @media (max-width: 640px) { margin-bottom: 16px; }\n\n  &__title-row { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; }\n\n  &__title {\n    font-size: 28px;\n    font-weight: 700;\n    color: $color-neutral-dark;\n    margin: 0;\n    letter-spacing: -0.02em;\n    font-family: $font-stack;\n    line-height: 1.2;\n\n    @media (max-width: 640px) { font-size: 22px; }\n  }\n\n  &__meta { margin-top: 8px; font-size: 13px; color: $color-neutral-mid; }\n  &__dot { margin: 0 6px; }\n}\n\n.sesb-breadcrumb {\n  display: flex;\n  align-items: center;\n  list-style: none;\n  padding: 0;\n  margin: 0 0 8px;\n  font-size: 12px;\n  color: $color-neutral-mid;\n\n  li {\n    display: flex;\n    align-items: center;\n\n    &:not(:last-child)::after { content: '/'; margin: 0 8px; color: $color-neutral-mid; font-size: 11px; }\n\n    a {\n      color: $body-content-color;\n      text-decoration: none;\n      transition: color 0.15s ease;\n      &:hover { color: $clarify-color; }\n    }\n  }\n\n  &__current { color: $color-neutral-dark; font-weight: 600; }\n}\n\n.sesb-badge {\n  font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.4px;\n  padding: 3px 9px; border-radius: 20px;\n\n  &--split { background: rgba($clarify-color, 0.12); color: darken($clarify-color, 18%); }\n  &--active { background: rgba($develop-color, 0.12); color: darken($develop-color, 18%); }\n  &--expired { background: rgba($implement-color, 0.12); color: darken($implement-color, 12%); }\n}\n\n.sesb-toolbar, .sesb-selbar {\n  display: flex; align-items: center; gap: 8px; flex-wrap: wrap; margin-bottom: 14px;\n  &__gap { flex: 1; }\n}\n.sesb-selbar {\n  background: rgba($clarify-color, 0.06); border: 1px solid rgba($clarify-color, 0.28);\n  border-radius: 8px; padding: 8px 12px;\n  &__n { font-size: 13px; font-weight: 600; color: darken($clarify-color, 18%); margin-right: 4px; }\n}\n\n// Group-level selection bar. Same chrome as the participant one — they can be open together, so\n// the heavier left edge plus the \"N groups selected\" count is what tells them apart.\n.sesb-selbar--groups { border-left-width: 3px; }\n\n// ── Toolbar buttons — modern standard (matches the listing's .sesl-btn). Self-contained here so\n// the board never depends on invitation-detail's `.invd-btn` being mounted (it isn't, on /sessions).\n.sesb-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 34px;\n  padding: 0 14px;\n  border: 1px solid $color-grey-1;\n  border-radius: 6px;\n  background: #fff;\n  color: $color-neutral-dark;\n  font-size: 13px;\n  font-weight: 600;\n  font-family: $font-stack;\n  line-height: 1;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: all 0.15s ease;\n\n  i { font-size: 12px; }\n  &:hover { background: $color-neutral-light; border-color: darken($color-grey-1, 6%); }\n\n  &--primary {\n    background: $develop-color; color: #fff; border-color: $develop-color;\n    &:hover { background: $color-dark-green; border-color: $color-dark-green; }\n  }\n\n  &--danger {\n    color: $implement-color; border-color: rgba($implement-color, 0.4);\n    &:hover { background: rgba($implement-color, 0.08); border-color: $implement-color; }\n  }\n\n  &--ghost {\n    border-color: transparent; background: transparent; color: $color-neutral-mid;\n    &:hover { background: $color-neutral-light; color: $color-neutral-dark; }\n  }\n\n  &:focus-visible { outline: 2px solid $develop-color; outline-offset: 1px; }\n}\n\n// ── Download split-button dropdown (namespaced; replaces .invd-dl) ──\n.sesb-dl {\n  position: relative;\n\n  &__caret { margin-left: 2px; font-size: 11px; }\n  &__backdrop { position: fixed; inset: 0; z-index: 10; }\n  &__menu {\n    position: absolute; top: calc(100% + 6px); left: 0; z-index: 11;\n    min-width: 200px; padding: 6px;\n    background: #fff; border: 1px solid $color-grey-1; border-radius: 8px;\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n  }\n  &__item {\n    display: flex; align-items: center; gap: 8px; width: 100%;\n    padding: 8px 10px; border: none; border-radius: 6px; background: transparent;\n    color: $color-neutral-dark; font-size: 13px; font-weight: 500; font-family: $font-stack;\n    text-align: left; cursor: pointer;\n    i { font-size: 12px; color: $color-neutral-mid; }\n    &:hover { background: $color-neutral-light; }\n  }\n}\n\n// Keeps the \"Move to group\" combobox a sane width in the selection bar, rather than\n// stretching full-width like a form field. Styles are global (ViewEncapsulation.None), so\n// .fsc__control below is the same rule the combobox's own stylesheet would apply.\n.sesb-movebox {\n  width: 200px;\n  .fsc__control { height: 34px; padding-top: 0; padding-bottom: 0; }\n}\n\n// ── invkm modal chrome (base) ──\n// Duplicated from invitation-detail.component.scss (and inventory.component.scss, which has its\n// own copy too). Both `app-session-create-modal` and `app-fs-report-download` use the `.invkm`\n// chrome, but the board page — not invitation-detail/inventory — is what's mounted on\n// `/sessions/:id`, and styles only apply globally (ViewEncapsulation.None) while their owning\n// component is mounted. Without this, the board's modals rendered with no overlay/backdrop and\n// position:static. A shared `_invkm-modal.scss` partial imported by all three is the eventual DRY\n// fix; deliberately out of scope here to avoid touching the two already-working components.\n.invkm {\n  position: fixed;\n  inset: 0;\n  z-index: 100000;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 50px 20px;\n\n  @media #{$mobile-up} { padding-left: 240px; }\n\n  &__overlay { position: fixed; inset: 0; background: rgba(0, 0, 0, 0.45); z-index: 0; }\n  &__card {\n    position: relative;\n    z-index: 1;\n    width: min(500px, 100%);\n    max-height: calc(100vh - 100px);\n    display: flex;\n    flex-direction: column;\n    background: #fff;\n    border-radius: 12px;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.18), 0 0 0 1px rgba(0, 0, 0, 0.04);\n    overflow: hidden;\n  }\n  &__header {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 16px 20px;\n    background: linear-gradient(135deg, $color-neutral-light, darken($color-neutral-light, 2%));\n    border-bottom: 1px solid $color-grey-1;\n  }\n  &__header-icon { width: 36px; height: 36px; border-radius: 8px; background: $develop-color; color: #fff; display: flex; align-items: center; justify-content: center; font-size: 14px; flex-shrink: 0; }\n  &__title { font-size: 15px; font-weight: 700; color: $color-neutral-dark; font-family: $font-stack; margin: 0; line-height: 1.3; }\n  &__subtitle { font-size: 12px; color: $body-content-color; margin: 2px 0 0; line-height: 1.3; opacity: 0.7; }\n  &__close {\n    margin-left: auto; width: 30px; height: 30px; border: 1px solid $color-grey-1; border-radius: 6px; background: #fff;\n    cursor: pointer; display: flex; align-items: center; justify-content: center; font-size: 13px; color: $color-neutral-mid;\n    transition: all 0.15s ease; flex-shrink: 0;\n    &:hover { background: rgba($implement-color, 0.06); color: $implement-color; border-color: rgba($implement-color, 0.2); }\n  }\n  &__body { padding: 20px; overflow-y: auto; }\n  &__section { font-size: 13px; font-weight: 700; color: $color-neutral-dark; margin: 0 0 14px; }\n  &__footer { display: flex; justify-content: flex-end; gap: 10px; padding: 12px 20px; border-top: 1px solid $color-grey-1; }\n}\n\n// Copied likewise: the create/re-split modal's form fields and the download panel's buttons.\n.invkm-field {\n  margin-bottom: 16px;\n  label { display: block; font-size: 12px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em; color: $color-neutral-dark; margin-bottom: 6px; }\n  .form-control {\n    width: 100%; padding: 9px 12px; font-size: 13px; border: 1px solid $color-grey-1; border-radius: 6px;\n    color: $body-content-color; background: #fff; outline: none; transition: border-color 0.2s ease, box-shadow 0.2s ease;\n    &:focus { border-color: $clarify-color; box-shadow: 0 0 0 3px rgba($clarify-color, 0.1); }\n  }\n}\n.invkm-req { color: $implement-color; }\n\n.invkm-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 9px 18px;\n  font-size: 13px;\n  font-weight: 600;\n  font-family: $font-stack;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n\n  &--primary { background: $develop-color; color: #fff; &:hover { background: darken($develop-color, 8%); } &[disabled] { opacity: 0.5; cursor: not-allowed; } }\n  &--purchase { background: $clarify-color; color: #fff; margin-top: 14px; width: 100%; &:hover { background: darken($clarify-color, 8%); } }\n  &--ghost { background: none; color: $color-neutral-mid; border-color: transparent; &:hover { color: $body-content-color; } }\n}\n\n// Copied from session-create-modal.component.scss / inventory.component.scss: `.invkm__card` is\n// declared in multiple stylesheets and ViewEncapsulation.None makes them one global rule decided\n// by source order, so this modifier is scoped `.invkm ...` to win regardless of load order — the\n// re-split modal's split-type dropdown is absolutely positioned and would otherwise be clipped by\n// the card's overflow:hidden.\n.invkm .invkm__card--combo {\n  overflow: visible;\n  max-height: none;\n  .invkm__header { border-radius: 12px 12px 0 0; }\n  .invkm__footer { border-radius: 0 0 12px 12px; }\n}\n.invkm .invkm__body--combo { overflow: visible; }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
